import { Box, MantineStyleSystemProps } from "@mantine/core";
import { PropsWithChildren, ReactElement, forwardRef } from "react";
import { useStyles } from "./InlineFlex.styled";
import { IInlineFlexProps } from "./types";

export default forwardRef<HTMLDivElement, PropsWithChildren<IInlineFlexProps>>(
  function InlineFlex(
    {
      align,
      columnGap,
      direction,
      gap,
      justify,
      rowGap,
      wrap,
      children,
      ...props
    }: PropsWithChildren<IInlineFlexProps>,
    ref,
  ): ReactElement {
    const { classes } = useStyles({
      align,
      columnGap,
      direction,
      gap,
      justify,
      rowGap,
      wrap,
    });

    return (
      <Box
        {...(props as MantineStyleSystemProps)}
        ref={ref}
        className={classes.box}
      >
        {children}
      </Box>
    );
  },
);
